<template>
  <v-app>
    <head>
      <!-- Global site tag (gtag.js) - Google Analytics -->
      <!-- Global site tag (gtag.js) - Google Analytics -->

      <title>Ruby技術者認定試験一問一答</title>
    </head>
    <Header></Header>
    <router-view></router-view>
  </v-app>
</template>

<script>
window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-136399435-2');
import Header from './components/Header'

export default {
  name: 'App',
  components: {
    Header
  },
  data: () => ({
    //
  }),
  
};
</script>

<style>
body{
  padding-top:50px;
}

.v-application--wrap{
    min-height: 0;
}


</style>
